<template>
  <div>
    <div class="text-right">
      <b-button aria-controls="log_search_collapse" class="btn-sm ml-2" v-b-tooltip.hover :title="$t('buttons.search')"  v-b-toggle.log_search_collapse variant="primary"><i class="fa fa-filter"></i></b-button>
    </div>
    <div>
      <b-collapse id="log_search_collapse" class="mt-2">
        <LogFiltering @getPage="getPage($event)"></LogFiltering>
      </b-collapse>
    </div>
  <b-row>
    <b-col v-if="isLoading">
      <Loader size="lg"></Loader>
    </b-col>
    <b-col v-else>
      <b-row>
        <b-col>
          <div
            v-if="error"
            class="alert alert-dismissible alert-danger">{{ error }}</div>
        </b-col>
      </b-row>
      <b-row>
        <b-col>
            <template v-if="isLoading">
              <Loader></Loader>
            </template>
            <template v-else>
              <div v-if="items.length > 0">
                  <table class="table table-striped table-hover">
                    <thead>
                      <tr>
                        <th>{{$t('views.log.list.table.createdAt')}}</th>
                        <th>{{$t('views.log.list.table.message')}}</th>
                        <th>{{$t('views.log.list.table.userName')}}</th>
                        <th>{{$t('views.log.list.table.userDataName')}}</th>
                      </tr>
                    </thead>
                    <tbody>
                      <tr
                        v-for="item in items"
                        :key="item['@id']">
                        <td>{{ $moment(item.createdAt).format('YYYY-MM-DD HH:mm') }}</td>
                        <td>{{ item.message }}</td>
                        <td>{{ item.context.userName }}</td>
                        <td>{{ item.context.userDataName }}</td>
                      </tr>
                    </tbody>
                  </table>
              </div>
              <div v-if="view">
                <pagination
                  :view="view"
                  @getPage="getPage($event)"
                ></pagination>
              </div>
            </template>
        </b-col>
      </b-row>
    </b-col>
    </b-row>
  </div>
</template>

<script>
import { mapActions, mapGetters } from 'vuex'
import Pagination from '../../Layout/Pagination'
import Loader from '../../Layout/Loader'
import LogFiltering from '@/components/Dashboard/Views/log/components/LogFiltering'
import { checkPagePermission } from '@/utils/checkRoles'

export default {
  name: 'LogList',
  computed: mapGetters({
    error: 'log/list/error',
    items: 'log/list/items',
    isLoading: 'log/list/isLoading',
    view: 'log/list/view'
  }),
  components: {
    LogFiltering,
    Pagination,
    Loader
  },
  beforeCreate () {
    checkPagePermission('configuration', 'LogList')
  },
  created () {
    this.getPage()
  },

  methods: {
    ...mapActions({
      getPage: 'log/list/default'
    })
  }
}
</script>
